import styled, { css } from 'styled-components';
import {
  iconStyling,
  outerSectionStyling,
  sectionButtonStyling,
  sectionTitleStyling,
} from '../../commonStyles/accordionSection';
import spacing from '../../helpers/spacing';
import { Grid, GridItem } from '../Grid';
import Icon from '../Icon';

export const AccordionGrid = styled(Grid)`
  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};
  }
`;

// These empty styles are used in motability theme and motability brochureware
export const AccordionGridItem = styled(GridItem)``;

type InnerSectionWrapperProps = {
  isVisible: boolean;
  animationTimeMs: number;
};

export const InnerSectionsWrapper = styled.div<InnerSectionWrapperProps>`
  // the contents of the accordion must be hidden to appease screenreaders when there is a
  // focusable element within. The transition is needed to keep the contents visible during the
  // close animation
  * {
    visibility: visible;
    transition-delay: ${({ animationTimeMs }) => animationTimeMs}ms;
    transition-property: visibility;

    ${({ isVisible }) =>
      !isVisible &&
      css`
        visibility: hidden;
      `}
  }
`;

export const OuterSection = styled.div`
  ${outerSectionStyling}
`;

export const SectionButton = styled.button`
  ${sectionButtonStyling}
`;

export const SectionTitle = styled.h2`
  ${sectionTitleStyling}
`;

export const StyledIcon = styled(Icon)`
  ${iconStyling}
`;
